/**
 * Removes the prefix of a string with an image in Base64.
 * @function
 * @name removeBase64Prefix
 * @kind function
 * @param {string} input String with an image in Base64.
 * @param {string} extension The intended extension of the image.
 * @returns {string} String with an image in Base64, without the prefix.
 */
export function removeBase64Prefix(input: string, extension = "jpeg"): string {
  let prefix = "";
  if (extension === "jpeg" || extension === "jpg" || extension === "png") {
    prefix = `data:image/${extension};base64,`;
  }

  if (extension === "pdf") {
    prefix = `data:application/${extension};base64,`;
  }

  return input.startsWith(prefix) ? input.substring(prefix.length) : input;
}
